
import '../styles/style.css'
import '../styles/arabic.css'
import '../styles/light-mode.css'
export default function LoadingAnimation() {
    return (
        <div className="iphone">
            <div className="bar" style={{ "--i": 0 }}></div>
            <div className="bar" style={{ "--i": 1 }}></div>
            <div className="bar" style={{ "--i": 2 }}></div>
            <div className="bar" style={{ "--i": 3 }}></div>
            <div className="bar" style={{ "--i": 4 }}></div>
            <div className="bar" style={{ "--i": 5 }}></div>
            <div className="bar" style={{ "--i": 6 }}></div>
            <div className="bar" style={{ "--i": 7 }}></div>
        </div>
    )
}
